
<template>
  <div ref="dv" class="fx-component-upload-container">
    <div @mousedown="mousedown" @mouseup="mouseup" ref="header" class="header">
      <div class="left">
        <span
          v-for="(item,index) in defaultConfig.tabs"
          :key="index"
          @click="changeTab(item.tab)"
          :class="{'active':defaultTab==item.tab}"
        >{{item.title}}</span>
      </div>
      <div class="right">
        <span v-if="!minimizeStatus" @click="minContainer">
          
          <i class="iconfont icon-fx-component-suoxiao"></i>
        </span>
        <span v-if="minimizeStatus" @click="maxContainer">
          <i class="iconfont icon-fx-check-box-no-check"></i>
        </span>
        <span @click="closeContainer">
          <i class="iconfont icon-fx-component-guanbi"></i>
        </span>
      </div>
    </div>
    <div v-show="!minimizeStatus" class="content">
      <div v-if="data.length==0" class="no-content">{{defaultConfig.placeholder}}</div>
      <div v-else>
        <div v-if="defaultTab=='fail'" class="fail-chongxin">
          您的网络可能不稳定，出现上传失败的文件，请选择
          <span @click="reupload" class="link">重新上传</span>
        </div>
        <file-item
          v-for="(item,index) in fileData"
          :key="index"
          @command="type=>command(type,item)"
          :type="item.type"
          :title="item.title"
          :percent="item.percent"
        >
          <template slot="upload-icon">
            <slot name="upload-icon"></slot>
          </template>
          <template slot="file-icon">
            <slot name="file-icon"></slot>
          </template>
          <template slot="success-icon">
            <slot name="success-icon"></slot>
          </template>
          <template slot="fail-icon">
            <slot name="fail-icon"></slot>
          </template>
        </file-item>
      </div>
    </div>
  </div>
</template>
<script>
import FileItem from "../fileItem/fileItem";
export default {
  name: "upload-container",
  components: { FileItem },
  props: {
    tabIndex: {
      type: String,
      default: "upload",
      required: false
    },
    config: {
      type: Object,
      default: function() {
        return {};
      },
      required: false
    },
    fileItemConfig: {
      type: Object,
      default: function() {
        return {
          command: function() {}
        };
      },
      required: false
    },
    data: {
      type: Array,
      default: function() {
        return [];
      },
      required: true
    }
  },
  watch: {
    data(val) {
      this.fileData = val;
    }
  },
  data() {
    return {
      isDown: false,
      defaultTab: this.tabIndex || "upload",
      minimizeStatus: false,
      dragObj: {},
      defaultConfig: Object.assign(
        {
          tabs: [
            {
              title: "上传中",
              tab: "upload"
            },
            {
              title: "上传失败",
              tab: "fail"
            },
            {
              title: "上传成功",
              tab: "success"
            }
          ],
          isDrag: true,
          placeholder: "暂无文件"
        },
        this.config
      ),
      fileData: this.data
    };
  },
  mounted() {
    window.onmousemove = e => {
      if (this.isDown == false) {
        return;
      }
      //获取x和y
      var nx = e.clientX;
      var ny = e.clientY;
      //计算移动后的左偏移量和顶部的偏移量
      var nl = nx - (this.dragObj.x - this.dragObj.l);
      var nt = ny - (this.dragObj.y - this.dragObj.t);
      this.$refs.dv.style = "";
      this.$refs.dv.style.left = nl + "px";
      this.$refs.dv.style.top = nt + "px";
    };
  },
  methods: {
    reupload() {
      this.$emit("reupload");
    },
    changeTab(tab) {
      this.defaultTab = tab;
      this.$emit("change", tab);
    },
    mousedown(e) {
      e.stopPropagation();
      if (this.defaultConfig.isDrag) {
        this.isDown = true;
        this.dragObj.x = e.clientX;
        this.dragObj.y = e.clientY;
        this.dragObj.l = this.$refs.dv.offsetLeft;
        this.dragObj.t = this.$refs.dv.offsetTop;
        this.$refs.header.style.cursor = "move";
      } else {
        this.isDown = false;
      }
    },
    mouseup() {
      this.isDown = false;
      this.$refs.header.style.cursor = "default";
    },
    minContainer(e) {
      e.stopPropagation();
      this.minimizeStatus = true;
      this.$refs.dv.style = "bottom:0;right:24px;";
      this.$emit("minimize");
    },
    maxContainer(e) {
      e.stopPropagation();
      this.minimizeStatus = false;
      this.$emit("maximize");
    },
    closeContainer(e) {
      e.stopPropagation();
      this.$emit("close");
    },
    command(type, file) {
      this.fileItemConfig.command(type, file);
    }
  }
};
</script>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.fx-component-upload-container {
  background-color: #ffffff;
  box-shadow: 0px -6px 12px 0px rgba(0, 0, 0, 0.1);
  border: solid 1px #e5e5e5;
  .content {
    height: 391px;
    overflow: auto;
    .fail-chongxin {
      height: 32px;
      font-family: "pingfang-biaozhun", "PingFangSC-Regular";
      font-size: 12px;
      padding: 0 20px;
      background-color: #f9fbfb;
      color: #666666;
      display: flex;
      align-items: center;
      width: 100%;
      .link {
        color: #1f81ff;
        cursor: pointer;
        margin: 0 5px;
      }
    }
    .no-content {
      height: 100%;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-family: "pingfang-biaozhun", "PingFangSC-Regular";
      font-size: 16px;
    }
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 1px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/
      background-color: #999999;
      border-radius: 2px;
      opacity: 0.4;
    }
    &::-webkit-scrollbar-track {
      /*滚动条里面轨道*/
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #ededed;
    }
  }
  .header {
    display: flex;
    align-items: center;
    height: 46px;
    border-bottom: 1px solid #e5e5e5;
    padding: 0 20px;
    .left {
      display: flex;
      align-items: center;
      flex-grow: 1;
      flex-shrink: 1;
      box-flex: 1;
      height: 46px;
      span + span {
        margin-left: 20px;
      }
      span {
        font-family: "pingfang-biaozhun", "PingFangSC-Regular";
        font-size: 14px;
        display: inline-block;
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #666666;
        &.active {
          color: #3e7fff;
          border-bottom: 2px solid #3e7fff;
        }
      }
    }
    .right {
      display: flex;
      align-items: center;
      flex-grow: 0;
      flex-shrink: 0;
      box-flex: 0;
      .iconfont {
        cursor: pointer;
      }
      span + span {
        margin-left: 16px;
      }
      .icon-fx-component-suoxiao {
        font-size: 25px;
      }
    }
  }
}
</style>

